import { Box, Button, Flex, Heading, Highlight, Stack } from "@chakra-ui/react";
import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import InternalErrorSVG from "../../utils/graphics/InternalErrorSVG";

const CriticalErrorPage = () => {
  const navigate = useNavigate();

  const onClickGoToDashboard = useCallback(() => {
    navigate("/dashboard");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickRetry = useCallback(() => {
    navigate(-1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      direction="column"
      gap={8}
      height="30vw"
      width="100%"
      justifyContent="center"
      alignItems="center"
    >
      <InternalErrorSVG />
      <Stack direction="column" gap={4} alignItems="center">
        <Heading>{"Ocorreu um erro"}</Heading>
        <Box>
          <Highlight query="Painel de Controlo" styles={{ fontWeight: "700" }}>
            {
              "Não foi possível mostrar esta página. Tente novamente ou regresse ao Painel de Controlo."
            }
          </Highlight>
        </Box>
      </Stack>
      <Stack direction="row" gap={4}>
        <Button variant="primary" onClick={onClickRetry}>
          {"Tentar novamente"}
        </Button>
        <Button variant="secondary" onClick={onClickGoToDashboard}>
          {"Ir para o Painel de Controlo"}
        </Button>
      </Stack>
    </Flex>
  );
};

export default memo(CriticalErrorPage);
